/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * How one provider import run entered the system; never a publisher setting.
 */
export type ImportChannel = typeof ImportChannel[keyof typeof ImportChannel];


export const ImportChannel = {
  elibri_feed: 'elibri_feed',
  elibri_requeue: 'elibri_requeue',
  sheet_cli: 'sheet_cli',
  sheet_ingest: 'sheet_ingest',
  admin_requeue: 'admin_requeue',
  file_ingest: 'file_ingest',
  reimport: 'reimport',
} as const;
